import React from "react";
import styled from "styled-components";

const Container = styled.div`
  height: 19.8px;
  width: 22.2px;
  margin: auto;

  text-align: center;

  @media (min-width: 1800px) {
    height: 24px;
    width: 27px;
  }

  @media (max-width: 575px) {
    height: 17.5px;
    width: 20px;
  }
`;

const LikeFilled = () => {
  return (
    <Container>
      <svg
        height="100%"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 17.607 20.013"
      >
        <path
          fill="#fff"
          d="M12.743 13.364a1.06 1.06 0 001.254-.823l.956-4.588a1.06 1.06 0 00-.823-1.254 1.061 1.061 0 00-1.254.823l-.956 4.588a1.058 1.058 0 00.823 1.254z"
        />
        <path
          fill="#fff"
          d="M16.944 14.908a20.445 20.445 0 00-.036-.516 1.456 1.456 0 01-.494.547 1.473 1.473 0 01-.823.245 1.5 1.5 0 01-1.476-1.81l.027-.129a1.509 1.509 0 01-1.183.587 1.437 1.437 0 01-.307-.031 1.5 1.5 0 01-1.165-1.778l.956-4.588a1.5 1.5 0 01.338-.671l.747-5.22a1.281 1.281 0 10-2.508-.525L9.546 9.893h-.3L7.585 2.432a1.281 1.281 0 00-1.449-1.089 1.281 1.281 0 00-1.089 1.449L6.932 13.68a16.362 16.362 0 00-1.663-2.939C4.647 10.1 2.361 7.75 1.183 8.207S-.48 9.5.605 10.582s2.556 2.468 2.859 4.246.742 3.855 2.081 4.548 3.094.347 4.153.311 4.731.751 5.655 0c.867-.707 1.792-1.111 1.592-4.779z"
        />
        <path
          fill="#fff"
          d="M15.375 14.716a1.061 1.061 0 001.254-.823l.956-4.588a1.061 1.061 0 00-.823-1.254 1.207 1.207 0 00-.218-.022 1.058 1.058 0 00-1.036.845l-.956 4.588a1.065 1.065 0 00.823 1.254z"
        />
      </svg>
    </Container>
  );
};

export default LikeFilled;
